import * as React from "react";
const SvgIconIncrement = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 11.25H3.75V7.5H7.5V3.75H11.25V0H15V15H0V11.25Z", fill: "currentColor" }));
export default SvgIconIncrement;
